import React from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import TextInput from 'client/generic/Forms/TextInput/TextInput.react';
import TextArea from 'client/generic/Forms/TextArea/TextArea.react';
import MarkdownRendererV2 from 'generic/MarkdownRendererV2/MarkdownRendererV2.react';
import {AuthoringSupplement as AuthoringSupplementModelV1} from 'resources/GeneratedModels/AuthoringSupplement/AuthoringSupplementModel.v1';
import './free-form-editor.scss';

export default class FreeFormEditor extends React.Component {
  static propTypes = {
    supplement: PropTypes.instanceOf(AuthoringSupplementModelV1),
    onChange: PropTypes.func,
    errors: ImmutablePropTypes.map
  };
  render() {
    const supplement = this.props.supplement;
    const errors = this.props.errors;
    return (
      <div className='free-form-editor'>
        <div className='free-form-editor__fieldset'>
          <TextInput
            className='free-form-editor__input'
            data-setter-method='setName'
            error={Boolean(errors.get('name'))}
            errorMessage={errors.get('name', null)}
            label='Name'
            name='name'
            onChange={this.props.onChange}
            value={supplement.getName()}
          />
          <TextArea
            className='free-form-editor__input free-form-editor__input--textarea'
            data-setter-method='setText'
            error={Boolean(errors.get('text'))}
            errorMessage={errors.get('text', null)}
            label='Text'
            name='text'
            onChange={this.props.onChange}
            value={supplement.getText()}
          />
        </div>
        <div className='free-form-editor-preview__wrapper'>
          <div className='a-form-input__label'>Preview</div>
          <MarkdownRendererV2
            className='free-form-editor__markdown-renderer'
            text={supplement.getText()}
          />
        </div>
      </div>
    );
  }
}
